export interface IParamBuilder {
  toParam(): any;
}
